import { render, staticRenderFns } from "./LegalContent.vue?vue&type=template&id=7e05590c&scoped=true&"
import script from "./LegalContent.vue?vue&type=script&lang=js&"
export * from "./LegalContent.vue?vue&type=script&lang=js&"
import style0 from "./LegalContent.vue?vue&type=style&index=0&id=7e05590c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e05590c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
